import powerColors from '@lib/colors/colorConsts'

// Color constants for the animated SVG gradients
export const LIGHT_PURPLE = '#C1BCFF'
export const TURQUOISE = '#37D8E7'
export const LIGHT_PINK = '#FFD9DD'
export const CORAL_PINK = '#FF9FA8'
export const MEDIUM_PINK = '#FFCFD4'
export const MEDIUM_PURPLE = powerColors.primary300 // #AD91FF
export const BRIGHT_PURPLE = '#C173FF'
export const MEDIUM_PURPLE_2 = '#9B7AFF'
export const BRIGHT_MAGENTA = '#E150FF'
export const MEDIUM_PURPLE_3 = '#A050FF'
export const LIGHT_BLUE = powerColors.blue200 // #A7CDFF
export const MEDIUM_BLUE = '#7AB5FF'
export const VERY_LIGHT_BLUE = '#C5DFFF'
export const ORANGE = powerColors.warm500 // #FFB600
export const YELLOW = '#FFD500'
export const DARK_ORANGE = '#FF9500'
export const SOFT_PEACH = '#FFD8BE' // pale peach / light coral
export const MINTY_CYAN = '#A8F7FF' // pastel cyan
export const BLOOM_WHITE = 'rgba(255,255,255,0.9)' // bright white with opacity
